<template>
	<template v-if="image">
		<w-avatar :size="40"> 
      <img :src="from=='manageHistory'&&userIcon!='default'?userIcon:imageAvatoUrl()" @dragstart="preventImageDrag"/>
    </w-avatar>
	</template>
	<template v-else>
		<template v-if="icon === 'xiaoya'||icon==='search'">
			<div style="width: 40px"></div>
      <div v-if="props.isLoading" class="bot-img ">
        <img :src="getIconUrlGif()" v-if="icon==='search'" alt="" @dragstart="preventImageDrag">
        <img :src="getXiaoYaGif()" v-else alt="" @dragstart="preventImageDrag">
      </div>
      <div v-else class="bot-img img-gif">
        <img :src="getIconUrl()" alt="" @dragstart="preventImageDrag">
      </div>
			<!-- <div v-if="visibleGIF" class="bot-img ">
				<canvas width="100" height="100" ref="apngImg"></canvas>
			</div>
			<div v-show="!visibleGIF" class="bot-img img-gif">
				<img :src="BotAvatar"  @dragstart="preventImageDrag"/>
			</div> -->
		</template>
		<template v-else>
      <w-avatar :class="[props.isLoading ? 'avatar' : '']">
					<img :src="icon ? getIconUrl() : isNew ? newIcon : BotAvatar" @dragstart="preventImageDrag"/>
				</w-avatar>
		</template>
	</template>
</template>

<script lang="ts" setup>
import { computed, ref, onMounted, nextTick, watch } from 'vue';
import parseAPNG from 'apng-js';
import { useUserInfo } from '/@/stores/userInfo';
import defaultAvatar from '/@common/assets/chat/avatar.svg';
import newIcon from '/@common/assets/h5/chat/role/xiaoya.png';
import BotAvatar from '/@/assets/h5/chat/role/xiaoya-gif-ezgif.com-gif-to-apng-converter (1).png';
import BotAvatarGIF from '/@/assets/h5/chat/role/xiaoya-gif-ezgif.com-gif-to-apng-converter.png';
interface Props {
	image?: boolean;
	isLoading?: boolean;
	icon?: string;
	isLast?: boolean;
  userIcon?:string;
  from?:string
}
const stores = useUserInfo();
const props = defineProps<Props>();
const apngImg = ref<HTMLCanvasElement | null>(null);
const visibleGIF = ref(props.isLoading);
const isNew = computed(() => window.location.host === 'new-yayi.wenge.com');
const getIconUrl = () => {
  let name=props.icon
  if(name=='xiaoya'){
		name=localStorage.getItem('winbox-theme')?'xiaoyanewYear': 'xiaoya'
	}
  return `${location.origin}/chat/cdn/roleSvg/${name}.svg` 
};
const getIconUrlGif= () =>  {return `${location.origin}/chat/cdn/roleSvg/${props.icon}.gif`};
// const getIconUrl = () => new URL(`../../assets/roleSvg/${props.icon}.svg`, import.meta.url).href;
// const getIconUrlGif= () => new URL(`../../assets/roleSvg/${props.icon}.gif`, import.meta.url).href;
// 获取图片并转化成 ArrayBuffer
const getImgBuffer = async (url: string): Promise<ArrayBuffer> => {
	const response = await fetch(url);
	const blob = await response.blob();
	return await blob.arrayBuffer();
};
const getXiaoYaGif=()=>{
	let name= localStorage.getItem('winbox-theme')?'xiaoyanewYear': 'xiaoya'
	return  `${location.origin}/chat/cdn/roleSvg/${name}.gif`;
}
const imageAvatoUrl = () => {  
  let name='defaultAvator'
	name=localStorage.getItem('winbox-theme')?name+localStorage.getItem('winbox-theme'):name
  if(stores?.userInfos?.headImg&&props?.from!='manageHistory'){
       return stores?.userInfos?.headImg
	}else{
	return `${location.origin}/chat/cdn/roleSvg/${name}.svg`;
  }

};
const preventImageDrag = (event) => {
  event.preventDefault(); // 阻止默认行为
};
// 创建 apng-js 的 player 实例
const createApngPlayer = async (url: string, ctx: CanvasRenderingContext2D, options = {}): Promise<any> => {
	const imgBuffer = await getImgBuffer(url);
	const apng = parseAPNG(imgBuffer);
	Object.assign(apng, options);
	return await apng.getPlayer(ctx);
};

// 控制 apng 的播放
const playApng = async () => apngImg.value?.getContext('2d');
let mark = true;
// 停止播放 apng
const stopApng = (player: any) => {
	mark = false;
	player && player.stop();
	setTimeout(() => {
		visibleGIF.value = false;
	}, 100);
};


watch(
	() => props.isLoading,
	(newVal: boolean) => {
		if (newVal ) {
			visibleGIF.value = true
		}
	}
);

watch(
  () => apngImg.value,
	(newVal) => {
    if (newVal) {
      initApngPlayer();
    }
  }
);

const initApngPlayer = async () => {
	mark = true;
  const ctx = apngImg.value?.getContext('2d');
  if (ctx) {
    const player1 = await createApngPlayer(BotAvatarGIF, ctx, {});
    player1.play();
	  player1.emit = (event, args) => {
      if (args === 0 && !props.isLoading && mark) {
        stopApng(player1);
      }
    };
  }
};


const init = async () => {
	// if (!props.image && props.isLast) {
	// 	await nextTick();
	// }
};

onMounted(init);
</script>

<style lang="scss" scoped>
.w-avatar {
	width: 40px;
	height: 40px;
	background-color: transparent;
	box-shadow: 0 0 13px rgba(0, 0, 0, 0.1);
  border: 2px solid #fff;
  position: relative;
}

.avatar {
  animation: boderAnim 1.2s infinite ease;
  border: 2px solid rgb(var(--primary-6));

  box-sizing: border-box;
}
.avatar:nth-child(1) img {
    animation: breath 1.2s infinite ease;
    border-radius: 50px
}

.avatar:nth-child(1):after {
    display: block;
    content: "";
    width: 42px;
    height: 42px;
    border: 1px solid rgba(var(--primary-6),0.6);
    border-radius: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    animation: circles 1.2s infinite ease,circlesOpa 1.2s infinite ease
}
.bot-img {
	width: 100%;
	height: 100%;
	background-color: transparent;
	position: relative;
}
.bot-img canvas,
.bot-img img {
	// position: absolute;
	width: 100px;
	height: 100px;
	max-width: 100px;
	zoom: 0.4;
	left: -40px;
	top: 40px;
	border-radius: 50%;
}
.img-gif {
	// z-index: 5;
}


@keyframes boderAnim {
    0%,to {
        border-color: var(---border-color)
    }

    50% {
        border-color: rgb(var(--primary-6))
    }
}


@keyframes show {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
}

@keyframes circles {
    0% {
        width: 42px;
        height: 42px
    }

    to {
        width: 52px;
        height: 52px
    }
}

@keyframes circlesOpa {
    0%,to {
        opacity: 0
    }

    20% {
        opacity: .6
    }
}
@keyframes breath {
    0%,to {
        transform: scale(.9);
        transform-origin: 50% 50%
    }

    50% {
        transform: scale(.9);
        transform-origin: 50% 50%
    }
}


</style>
<style>
</style>
